import { render } from "./EditCustomSetting.vue?vue&type=template&id=e82b33d2&scoped=true&ts=true"
import script from "./EditCustomSetting.vue?vue&type=script&lang=ts"
export * from "./EditCustomSetting.vue?vue&type=script&lang=ts"

import "./EditCustomSetting.vue?vue&type=style&index=0&id=e82b33d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e82b33d2"]])

export default __exports__